export function parseDateOrNull(
  input: string | null | undefined | Date
): Date | null {
  if (input instanceof Date) {
    return input;
  }
  try {
    if (!input) {
      return null;
    }
    const date = new Date(input);
    // check if date is valid
    if (Number.isNaN(date.getTime())) {
      return null;
    }
    return date;
  } catch {
    return null;
  }
}
